import { Box, styled, darken } from '@mui/material';
import distributionInfoBG from 'assets/images/distributionInfo_bg.png';

export const StyledContainer = styled(Box)({
  containerType: 'inline-size',
  width: '100%',
});

export const StyledBackgroundImageContainer = styled(Box)(({ theme }) => ({
  containerType: 'inline-size',
  padding: theme.spacing(5),
  width: '100%',
  borderRadius: theme.spacing(1),
  backgroundColor: darken(theme.palette.grey[700], 0.4),
  backgroundImage: `url(${distributionInfoBG})`,
  backgroundSize: 'cover',
  [`@container (max-width: ${theme.breakpoints.values.xl}px)`]: {
    backgroundSize: 'auto',
  },
  [theme.breakpoints.down('sm')]: {
    backgroundPosition: '38% -33%',
    backgroundRepeat: 'no-repeat',
    padding: theme.spacing(3),
  },
}));

export const StyledDisitributionInfoContainer = styled(Box)(({ theme }) => ({
  maxWidth: theme.spacing(93),
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    flexDirection: 'column',
  },
}));
